import { TAB_BAR_HEIGHT } from '../../../../layouts/mobile/MobileTabs';
import { ChatAction } from '../../../labs/actions/ChatAction';
import { TOOLBAR_DESKTOP_HEIGHT } from '@orthly/ui';
import { FlossPalette, styled, useScreenIsMobile, Text } from '@orthly/ui-primitives';
import dayjs from 'dayjs';
import React from 'react';

const Layout = styled('div')({
    background: FlossPalette.TAN,
    borderLeft: `1px solid ${FlossPalette.STROKE_LIGHT}`,
    height: '100%',
    position: 'relative',
});

const SidebarSection = styled('div')({
    width: '100%',
    padding: '0 20px',
});

const FixedSidebarSection = styled(SidebarSection)(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    overflowY: 'auto',
    [theme.breakpoints.down('lg')]: {
        bottom: `${TAB_BAR_HEIGHT}px`,
    },
}));

const PatientData = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: TOOLBAR_DESKTOP_HEIGHT,
    borderBottom: `1px solid ${FlossPalette.STROKE_LIGHT}`,
});

const ChatLayout = styled('div')({
    borderTop: `1px solid ${FlossPalette.STROKE_LIGHT}`,
    padding: '16px 0',
});

interface PatientDetailSidebarProps {
    cases: number;
    lastVisit?: string | null;
}

/**
 * Renders the right-hand sidebar for use on the Patient Detail page (see [storybook](https://storybook-dev.dandyserv.net/main/practice/index.html?path=/story/patients-patient-detail-patientdetailsidebar--patient-detail-sidebar)).
 */
export const PatientDetailSidebar: React.VFC<PatientDetailSidebarProps> = props => {
    const { cases, lastVisit } = props;

    const isMobile = useScreenIsMobile();

    if (isMobile) {
        return null;
    }

    return (
        <Layout>
            <SidebarSection>
                <PatientData>
                    <Text variant={'body1'} medium color={'DARK_GRAY'}>
                        Cases
                    </Text>
                    <Text variant={'h6'} medium>
                        {cases}
                    </Text>
                </PatientData>

                {lastVisit && (
                    <PatientData>
                        <Text variant={'body1'} medium color={'DARK_GRAY'}>
                            Last Visit
                        </Text>
                        <Text variant={'h6'} medium>
                            {dayjs(lastVisit).format('MMM D, YYYY')}
                        </Text>
                    </PatientData>
                )}
            </SidebarSection>

            <FixedSidebarSection>
                <ChatLayout>
                    <Text variant={'body2'} medium color={'GRAY'}>
                        Need a hand?
                    </Text>
                    <ChatAction />
                </ChatLayout>
            </FixedSidebarSection>
        </Layout>
    );
};
